import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {Template, TemplateDownload} from "./template.model";
import {IEntityInfo} from "../app-store.interfaces";

@Injectable({providedIn: 'root'})
export class TemplateService {
    constructor(private http: HttpClient) {
    }

    clone(id: number, cloneProducts: boolean): Observable<Template> {
        return this.http.get<Template>(
            `${environment.rootUrl}/template/clone/${id}/${cloneProducts}`
        );
    }

    hasProducts(templateId: number): Observable<boolean> {
        return this.http
            .get<boolean>(`${environment.rootUrl}/template/has-products/${templateId}`)
            .pipe(first());
    }

  createManyTemplates( templates: Template[], createNewCategory: boolean ): Observable<Template[]> {
    return this.http.post<Template[]>(
      `${environment.rootUrl}/template/create-many-templates/`, {templates, createNewCategory});
  }

  downloadTemplates(data : TemplateDownload){
    return this.http.post(`${environment.rootUrl}/template/download-images`, {...data},
      {
        responseType: 'blob',
        observe: 'response' // Observe the full response to access headers
      });
  }

  saveDraft(template: Template): Observable<Template> {
    if (template.id) {
      return this.http.patch<Template>(`${environment.rootUrl}/template`, template);
    } else {
      return this.http.post<Template>(`${environment.rootUrl}/template`, template);
    }
  }

  loadDraft(productCategoryId: number): Observable<Template | null> {
    return this.http.get<Template | null>(
      `${environment.rootUrl}/template/draft/${productCategoryId}`
    );
  }

  addToCategories(templateIds: number[], categoryIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.rootUrl}/template/add-to-categories`,
      { entityIds: templateIds, categoryIds }
    );
  }

  cloneToCategories(templateIds: number[], categoryIds: number[], name?: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.rootUrl}/template/clone-to-categories`,
      { entityIds: templateIds, categoryIds, name }
    );
  }

  moveToCategories(templateIds: number[], categoryIds: number[]): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.rootUrl}/template/move-to-categories`,
      { entityIds: templateIds, categoryIds }
    );
  }

  removeFromCategory(templateId: number, categoryId: number): Observable<boolean> {
    return this.http.delete<boolean>(
      `${environment.rootUrl}/template/remove-from-category/${templateId}/${categoryId}`
    );
  }
}
